var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7168 7.72959H8.12188C5.57737 7.72959 3.43869 9.64054 3.1534 12.169L0.781693 33.1894C0.447195 36.154 2.76672 38.75 5.75017 38.75H30.5584C33.5419 38.75 35.8614 36.1541 35.5269 33.1894L33.1552 12.169C32.8699 9.64054 30.7312 7.72959 28.1867 7.72959H24.6543M11.7168 7.72959C11.7168 7.72959 11.1387 0.75 18.0762 0.75C25.0137 0.75 24.6543 7.72959 24.6543 7.72959M11.7168 7.72959H24.6543M11.7168 16.2602C11.7168 16.2602 10.5605 24.877 18.0762 24.877C25.5918 24.877 24.6543 16.2602 24.6543 16.2602",
    stroke: "url(#paint0_linear_11561_43162)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11561_43162",
    x1: -5.89571,
    y1: 79.6,
    x2: -41.3091,
    y2: 51.3065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon2);
export default __webpack_public_path__ + "static/media/shop_icon2.56a1227c8efa09d2bca44cf2468d87aa.svg";
export { ForwardRef as ReactComponent };